/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetCallOrderPathParameters } from 'api/actions/get-call-order/get-call-order-path-parameters';
import { GetCallOrderResponse } from 'api/actions/get-call-order/get-call-order-response';

type GetCallOrderQueryParameters = Record<string, any>;

/**
 * The path of the GetCallOrder action.
 */
export const getCallOrderActionPath = new SweetPath<keyof GetCallOrderPathParameters>('/user/call-order', {
  path: '{param}',
});

/**
 * Creates a contextualized GetCallOrder actions.
 */
export default function createGetCallOrderAction(axios: AxiosInstance) {
  return function getCallOrderAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetCallOrderQueryParameters } = {}) {
    const path = getCallOrderActionPath.original;

    return axios.get<GetCallOrderResponse, GetCallOrderResponse>(path, { params: query, headers });
  };
}
